<template>
  <div class="recharge-result-page-container row">
    <div class="main row">
      <div class="main-content row" v-if="orderStatus&&orderStatusMap[orderStatus]">
        <div class="title">{{orderStatusMap[orderStatus].title}}</div>
        <div class="content row" :class="orderStatus" v-loading="loading">
          <img :src="require(`@/assets/img/${orderStatus}.svg`)" class="img"/>
          <div class="info row" v-if="userInfo&&orderStatus==='success'">
            <div class="account">账号： {{userInfo.username}}</div>
            <div class="time">到期时间： {{userInfo.expire_at}} </div>
          </div>
          <div class="fail" v-if="userInfo&&orderStatus==='fail'">支付失败，扫码重试</div>
        </div>
        <div class="button">
          <div class="success" v-if="orderStatus==='success'">
            <el-button class="gray-button" @click="$router.push('userCenter')">查看订单</el-button>
            <el-button class="blue-button" @click="$router.push('recharge')">返回</el-button>
          </div>
          <div class="fail" v-if="orderStatus==='fail'">
            <el-button class="blue-button" @click="$router.push('recharge')">扫码重试</el-button>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import api from '@/rest/questionQuery';

export default {
  name: 'RechargeResultPage',
  data() {
    return {
      loading: false,
      orderStatus: null,
      orderStatusMap: {
        success: {
          title: '支付成功'
        },
        fail: {
          title: '支付失败'
        }
      },
      userInfo: null
    };
  },
  methods: {
    async getUserInfo() {
      this.loading = true;
      try {
        const res = await api.getUserInfo();
        this.userInfo = res;
        this.loading = false;
        eventBus.$emit('rechargeResultPage', this.userInfo);
      } catch (err) {
        if (err.response && err.response.msg) {
          this.$message.error(err.response.msg);
        } else {
          this.$message.error('数据请求错误');
        }
        this.loading = false;
      }
    },
    init() {
      this.orderStatus = this.$route.query.orderstatus;
      if (!this.orderStatusMap[this.orderStatus]) {
        this.$message.error('页面错误');
        return;
      }
      this.getUserInfo();
    }
  },
  mounted() {
    this.init();
  }
};
</script>

<style lang="scss" scoped>
.recharge-result-page-container {
  justify-content: center;
  width: 100%;
  height: calc(100vh - 68px);
  overflow: hidden;
  .main {
    justify-content: center;
    margin-top: 24px;
    width: 1200px;
    height: calc(100% - 24px);
    background-color: #ffffff;
    .main-content {
      flex-direction: column;
      align-items: center;
      margin-top: 87px;
      width: 384px;
      height: 300px;
      .title {
        font-size: 24px;
      }
      .content {
        align-items: center;
        margin-top: 32px;
        width: 100%;
        height: 112px;
        background-color: gray;
        &.success {
          border: solid 1px #aff0d2;
          background-color: #f1fff8;
        }
        &.fail {
          border: solid 1px rgba(230, 76, 98, 0.6);
          background-color: rgba(230, 76, 98, 0.1);
        }
        .img {
          margin-left: 66px;
          margin-right: 32px;
        }
        .info {
          flex-direction: column;
          font-size: 14px;
        }
      }
      .button {
        margin-top: 32px;
      }
    }
  }
}
</style>
